import { gql } from '@apollo/client';
import { client } from "..";

export const updateQuery = gql`
mutation UpdateECCards($id: bigint = "", $_set: ec_cards_set_input = {}) {
  update_ec_cards_by_pk(pk_columns: {id: $id}, _set: $_set){
id
}
}

`;
export const assignCardToUser = async (data) => {
  let resp;
  try {
    // console.log(id, 'selected')
    let result = 
        {
            id: data?.qr_id,
            _set: {
              user_id: data?.user_id
            }
          };
    console.log(result,"mutate-result_mutFile");
    
    resp = await client.mutate({
      mutation: updateQuery,
      refetchQueries: [],
      variables: result,
      context: {
        headers: {
            "Content-Type": "application/json",
            //   "x-hasura-admin-secret": "aseraadmin@1234",
            'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
        },
    },
    });
    console.log(resp);
    
    if (resp.errors) {
      console.log(resp.errors)
     console.log("Uniqueness violation !",5);
      return resp.errors
    }
    // window.location.reload();
  } catch (e) {
    console.log(JSON.stringify(e));
  }
  console.log(`User card(s) updated`,5);
  return resp;
};